import { render } from "./InvoiceUploadModal.vue?vue&type=template&id=33a53986"
import script from "./InvoiceUploadModal.vue?vue&type=script&lang=js"
export * from "./InvoiceUploadModal.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./InvoiceUploadModal.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_9bf761c1%2Fpackages%2Fcustomer%2Fsrc%2Fcomponents%2Fclaim%2Fdetails%2Finformation%2Faction%2Finvoices%2FInvoiceUploadModal.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__